
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import BackToTop from "@/components/ui/BackToTop";
import { Shield, UserRound, Database, Mail } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 pt-20">
        <div className="container mx-auto px-4 py-12 max-w-4xl">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-nation-blue mb-4">Privacy Policy</h1>
            <p className="text-gray-600">
              Last updated: {new Date().toLocaleDateString()}
            </p>
          </div>
          
          <div className="grid gap-8">
            <Card className="border-l-4 border-l-nation-purple shadow-md">
              <CardContent className="p-6">
                <div className="flex items-start gap-4">
                  <Shield className="w-6 h-6 text-nation-purple flex-shrink-0 mt-1" />
                  <div>
                    <h2 className="text-2xl font-semibold text-nation-blue mb-4">1. Introduction</h2>
                    <p className="text-gray-700 leading-relaxed">
                      Welcome to NationCard™. This Privacy Policy explains how we collect, use, disclose, 
                      and safeguard your information when you use our service.
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card className="border-l-4 border-l-nation-purple shadow-md">
              <CardContent className="p-6">
                <div className="flex items-start gap-4">
                  <UserRound className="w-6 h-6 text-nation-purple flex-shrink-0 mt-1" />
                  <div>
                    <h2 className="text-2xl font-semibold text-nation-blue mb-4">2. Information We Collect</h2>
                    <p className="text-gray-700 mb-4 leading-relaxed">
                      We collect information that you provide directly to us, including but not limited to:
                    </p>
                    <ul className="list-disc pl-6 space-y-2 text-gray-700">
                      <li>Personal identification information (Name, email address, etc.)</li>
                      <li>Demographics information</li>
                      <li>Survey and polling responses</li>
                      <li>User-generated content</li>
                    </ul>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card className="border-l-4 border-l-nation-purple shadow-md">
              <CardContent className="p-6">
                <div className="flex items-start gap-4">
                  <Database className="w-6 h-6 text-nation-purple flex-shrink-0 mt-1" />
                  <div>
                    <h2 className="text-2xl font-semibold text-nation-blue mb-4">3. How We Use Your Information</h2>
                    <p className="text-gray-700 mb-4 leading-relaxed">
                      We use the information we collect to:
                    </p>
                    <ul className="list-disc pl-6 space-y-2 text-gray-700">
                      <li>Provide and maintain our service</li>
                      <li>Improve and personalize user experience</li>
                      <li>Analyze usage patterns and trends</li>
                      <li>Communicate with users</li>
                    </ul>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
};

export default PrivacyPolicy;
